exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sign .ant-input[data-v-2f602f2d]{\n  font-size: 30px;\n  font-weight:bolder;\n  text-align:center;\n  border-left-width:0px!important;\n  border-top-width:0px!important;\n  border-right-width:0px!important;\n}\n", ""]);

// exports
